import { render, staticRenderFns } from "./ItemCardHorizontal.vue?vue&type=template&id=79586ced&scoped=true"
import script from "./ItemCardHorizontal.vue?vue&type=script&lang=js"
export * from "./ItemCardHorizontal.vue?vue&type=script&lang=js"
import style0 from "./ItemCardHorizontal.vue?vue&type=style&index=0&id=79586ced&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79586ced",
  null
  
)

export default component.exports